<app-context-menu-heading>Sorting options:</app-context-menu-heading>

<app-context-menu-item
  [withCheckOption]="true"
  title="Title"
  [active]="listStore.options().sortBy === 'title'"
  [sortable]="true"
  [reversed]="listStore.options().sortOrder === 'desc'"
  (execute)="listStore.sort('title')"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Created Date"
  [active]="listStore.options().sortBy === 'createdAt'"
  [sortable]="true"
  [reversed]="listStore.options().sortOrder === 'desc'"
  (execute)="listStore.sort('createdAt')"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Updated Date"
  [active]="listStore.options().sortBy === 'updatedAt'"
  [sortable]="true"
  [reversed]="listStore.options().sortOrder === 'desc'"
  (execute)="listStore.sort('updatedAt')"
/>

<app-context-menu-divider />

<app-context-menu-item
  [withCheckOption]="true"
  title="Pinned on Top"
  [active]="listStore.options().pinnedOnTop"
  (execute)="listStore.togglePinnedOnTop()"
/>
@if (listStore.view() !== 'flagged' || listStore.folderId()) {
  <app-context-menu-item
    [withCheckOption]="true"
    title="Flagged on Top"
    [active]="listStore.options().flaggedOnTop"
    (execute)="listStore.toggleFlaggedOnTop()"
  />
}

<app-context-menu-heading>Filters:</app-context-menu-heading>

<app-context-menu-item
  [withCheckOption]="true"
  title="Flagged"
  [active]="listStore.options().flagged"
  (execute)="listStore.toggleFlaggedFilter()"
/>
<app-context-menu-item
  [withCheckOption]="true"
  title="Pinned"
  [active]="listStore.options().pinned"
  (execute)="listStore.togglePinnedFilter()"
/>
<app-context-menu-item [withCheckOption]="true" [active]="!!(listStore.options().from || listStore.options().to)" title="Selected Date">
  <div class="date">
    <div class="date-buttons">
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected() === 'from'"
        [class.active]="fromDate.value"
        (click)="dateButtonSelected.set('from')"
      >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ fromDate.value ? (fromDate.value | dateFormat: 'date') : 'After' }}</span>
      </div>
      <div
        class="date-buttons-item"
        [class.selected]="dateButtonSelected() === 'to'"
        [class.active]="toDate.value"
        (click)="dateButtonSelected.set('to')"
      >
        <app-icon class="date-buttons-item-icon" name="sapphire-events" [size]="16" />
        <span class="date-buttons-item-text">{{ toDate.value ? (toDate.value | dateFormat: 'date') : 'Before' }}</span>
      </div>
    </div>

    <app-date-picker-2
      [flush]="true"
      [inputFormControl]="dateButtonSelected() === 'from' ? fromDate : toDate"
      [collapseable]="false"
      [maxDate]="dateButtonSelected() === 'from' && toDate.value"
      [minDate]="dateButtonSelected() === 'to' && fromDate.value"
      [highlightRange]="true"
    />

    @if (fromDate.value || toDate.value) {
      <div class="flex justify-end pt-2">
        <app-button2 appearance="primary-text" size="s" (click)="clearSelectedDate()">Clear</app-button2>
      </div>
    }
  </div>
</app-context-menu-item>

@if (!listStore.foldersOpen()) {
<!-- Prototype BoardListOptions.tsx:49: the Forms content group. -->
<app-context-menu-heading>Forms content:</app-context-menu-heading>
<app-context-menu-item [withCheckOption]="true" title="All content" [active]="listStore.options().content === 'all'" (execute)="listStore.setContent('all')" />
<app-context-menu-item [withCheckOption]="true" title="Has questions" [active]="listStore.options().content === 'questions'" (execute)="listStore.setContent('questions')" />
<app-context-menu-item [withCheckOption]="true" title="Has responses" [active]="listStore.options().content === 'responses'" (execute)="listStore.setContent('responses')" />
<app-context-menu-item [withCheckOption]="true" title="Empty form" [active]="listStore.options().content === 'empty'" (execute)="listStore.setContent('empty')" />

}
<!-- Prototype BoardListOptions.tsx:50: clears only the filters; sorting, on-top and search stay. -->
<app-context-menu-item title="Clear filters" (execute)="listStore.clearFilters()" />
